import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVentilatierooster = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      d="M17.83 17.64a3.07 3.07 0 0 1 4-.11 8.6 8.6 0 0 0 1.1-3.31c.19-4.67-.72-5.8-2.46-7.16C17.45 4.72 13.79 6 15.13 10a80 80 0 0 0 2.7 7.64M16.74 20a3.16 3.16 0 0 1 .74-2 8.3 8.3 0 0 0-3.15-1c-4.67-.2-5.8.71-7.16 2.46-2.34 3-1.07 6.66 2.92 5.32 2.81-.94 5.59-1.75 7.49-2.63a3.13 3.13 0 0 1-.84-2.15M29.91 15a78 78 0 0 0-7.79 2.77c.577.598.893 1.4.88 2.23a3.17 3.17 0 0 1-.55 1.77 8.4 8.4 0 0 0 3.18 1c4.67.19 5.8-.72 7.16-2.46 2.38-2.97 1.11-6.63-2.88-5.31M22.17 22.15a3.1 3.1 0 0 1-4.13.39 8.2 8.2 0 0 0-.95 3c-.19 4.67.72 5.8 2.46 7.16 3 2.33 6.66 1.07 5.32-2.92a77 77 0 0 0-2.7-7.63"
    />
    <path
      fill="#15265B"
      fillRule="evenodd"
      d="M23.138 6.73a5.4 5.4 0 0 0-3.224-2.217l-.229.974a4.4 4.4 0 0 1 2.63 1.813l.007.01.007.009c.643.862 1.052 1.553 1.165 2.532.117 1.004-.072 2.366-.78 4.566l.952.306c.721-2.24.963-3.768.822-4.987-.144-1.24-.677-2.102-1.35-3.006M15.288 30.264c-.142-1.22.1-2.747.826-4.988l.952.308c-.714 2.2-.902 3.561-.784 4.564.114.979.525 1.67 1.169 2.533l.007.01.006.009a4.37 4.37 0 0 0 2.647 1.813l-.222.974a5.37 5.37 0 0 1-3.247-2.217c-.673-.904-1.209-1.766-1.354-3.006"
      clipRule="evenodd"
    />
    <path
      fill="#0061CD"
      d="M19.89 23.15a3.15 3.15 0 1 0 0-6.3 3.15 3.15 0 0 0 0 6.3"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVentilatierooster);

export default ForwardRef;
